/* Big Beetle Books — landing interactions (parallax + reveal) */
(function(){
  const root = document.getElementById('bbb-landing');
  if(!root) return;

  /* ===========================================================
     PARALLAX ENGINE  ·  v2 — section-relative & bounded
     ----------------------------------------------------------
     The old version multiplied a layer's speed by the GLOBAL
     scroll position. That meant a layer in section 6 accumulated
     a huge transform (scrollY ≈ 6000 × speed) and got yanked
     hundreds of px out of its box — clipped by overflow:hidden.
     That is exactly why the №03–06 numbers vanished.

     v2 measures each content layer's natural position ONCE, then
     offsets it by its distance from the viewport centre. The
     result is bounded: a layer never drifts more than roughly
     (viewportHeight × speed), so nothing escapes its section.

     · background layers (inside .bg, position:fixed) keep the
       classic scrollY drift — they're clipped to the viewport.
     · content layers (numbers, cards, characters…) use the
       bounded section-relative offset.
     · on phones we simplify hard: only the background and the
       character images move; every box stays put.
     =========================================================== */
  const layers   = [...root.querySelectorAll('[data-speed]')];
  const nav      = document.getElementById('bbb-nav');
  const progress = document.getElementById('bbb-progress');

  const mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mqPhone  = window.matchMedia('(max-width: 820px)');
  const mqTouch  = window.matchMedia('(hover: none), (pointer: coarse)');

  let reduce = mqReduce.matches;
  let phone  = mqPhone.matches;
  let touch  = mqTouch.matches;

  let scrollY = 0, mouseX = 0, mouseY = 0, vh = window.innerHeight, ticking = false;

  // classify + measure each layer once
  function measure(){
    vh = window.innerHeight;
    layers.forEach(el => {
      el._bg   = !!el.closest('.bg');         // fixed background decoration
      el._char = el.hasAttribute('data-mouse'); // a character image
      if(!el._bg){
        // natural document-space centre, measured WITHOUT transform
        const prev = el.style.transform;
        el.style.transform = 'none';
        const r = el.getBoundingClientRect();
        el._mid = r.top + window.scrollY + r.height / 2;
        el.style.transform = prev;
      }
    });
  }

  // visibility culling — skip work for off-screen layers
  const visible = new WeakMap();
  layers.forEach(el => visible.set(el, true));
  const visIO = new IntersectionObserver(entries => {
    entries.forEach(e => visible.set(e.target, e.isIntersecting));
  }, { rootMargin: '50% 0px 50% 0px' });
  layers.forEach(el => visIO.observe(el));

  function update(){
    const phoneMode = phone && !reduce;

    for(let i = 0; i < layers.length; i++){
      const el = layers[i];
      if(visible.get(el) === false) continue;

      const baseSpeed = parseFloat(el.dataset.speed || 0);
      let ty = 0, tx = 0;

      if(reduce){
        ty = 0;
      } else if(el._bg){
        // background decoration drifts with global scroll (clipped to viewport)
        ty = scrollY * baseSpeed * (phone ? 0.5 : 1);
      } else if(phoneMode && !el._char){
        // PHONE: content boxes stay put — no clipping, clean spacing
        ty = 0;
      } else {
        // section-relative bounded offset
        const centreInVP = el._mid - scrollY;          // where its centre is now
        const dist = centreInVP - vh / 2;              // distance from viewport centre
        const amp = phone ? 0.45 : 1;                  // gentler on phone
        ty = dist * baseSpeed * amp;
      }

      // pointer tilt — character images, desktop pointer only
      if(el._char && !touch && !reduce){
        tx = mouseX * 12;
        ty += mouseY * 8;
      }

      el.style.transform = (tx || ty)
        ? `translate3d(${tx}px, ${ty}px, 0)`
        : 'none';
    }

    // scroll-progress hairline
    const docH = document.documentElement.scrollHeight - vh;
    if(progress) progress.style.transform = `scaleX(${docH > 0 ? scrollY / docH : 0})`;

    // nav shrink
    if(nav) nav.classList.toggle('scrolled', scrollY > 60);

    ticking = false;
  }

  function requestUpdate(){
    if(!ticking){ requestAnimationFrame(update); ticking = true; }
  }

  function onScroll(){ scrollY = window.scrollY || 0; requestUpdate(); }

  function onMouse(e){
    if(touch || reduce) return;
    mouseX = (e.clientX - window.innerWidth / 2) / window.innerWidth;
    mouseY = (e.clientY - vh / 2) / vh;
    requestUpdate();
  }

  let resizeTimer;
  function onResize(){
    phone = mqPhone.matches; touch = mqTouch.matches; reduce = mqReduce.matches;
    clearTimeout(resizeTimer);
    // remeasure after layout settles (debounced — getBoundingClientRect is costly)
    resizeTimer = setTimeout(() => { measure(); update(); }, 150);
  }

  // boot
  measure();
  window.addEventListener('scroll', onScroll, { passive: true });
  if(!touch && !reduce) window.addEventListener('mousemove', onMouse, { passive: true });
  window.addEventListener('resize', onResize);
  mqReduce.addEventListener?.('change', onResize);
  // re-measure once fonts/images settle (their final heights shift the natural positions)
  window.addEventListener('load', () => { measure(); update(); });
  update();

  /* ===========================================================
     REVEAL  ·  opacity-only fade-in (no transform → no conflict)
     =========================================================== */
  const revealEls = root.querySelectorAll('.copy, .stage, .grid, .foot-grid');
  if(!reduce){
    revealEls.forEach(el => el.classList.add('reveal-target'));
    const revealIO = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if(e.isIntersecting){
          e.target.classList.add('revealed');
          revealIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    revealEls.forEach(el => revealIO.observe(el));
  }

})();
